/* global localStorage */
import React from 'react'
import { useActions, useValues } from 'kea'
import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/search/logic'

import './styles.scss'

function Pagination () {
  const { updateFilter } = useActions(sceneLogic)
  const { results, options, filter } = useValues(sceneLogic)

  const {
    page,
    pages,
    count,
    total,
    per_page: perPage,
    helmet: { link },
    online_landing_page_url: onlineLandingPageUrl,
    online_teachers_section: onlineTeachersSection
  } = results

  const { coords_from_location: coordsFromLocation } = options
  const { from_map: fromMap } = filter

  // When there are only online teachers (no location-based teachers), adjust the count display
  const hasOnlyOnlineTeachers = onlineTeachersSection && total === 0
  const start = hasOnlyOnlineTeachers ? 0 : (page - 1) * perPage + 1
  const end = hasOnlyOnlineTeachers ? count : (page - 1) * perPage + count
  const displayTotal = hasOnlyOnlineTeachers ? count : total

  const prevPage = link.filter(l => l.rel === 'prev')[0]
  const nextPage = link.filter(l => l.rel === 'next')[0]

  const handlePrevPage = e => {
    e.preventDefault()

    updateFilter({ page: page - 1, coords_from_location: fromMap ? false : coordsFromLocation })
  }

  const handleNextPage = e => {
    e.preventDefault()

    updateFilter({ page: page + 1, coords_from_location: fromMap ? false : coordsFromLocation })
  }

  const handleGoOnlinePage = event => {
    event.preventDefault()
    localStorage.setItem('redirectFromActivityLandingPage', window.location.pathname)
    window.location.href = onlineLandingPageUrl
  }

  return (
    <div className='results-pagination'>
      <div className='left-button'>
        <a
          className='button'
          href={prevPage ? prevPage.href : '#'}
          onClick={handlePrevPage}
          style={{ visibility: page > 1 ? 'visible' : 'hidden' }}
        >
          <span className='regular'>{I18n.t('main.index.previous_page')}</span>
          <span className='mobile'>«</span>
        </a>
      </div>
      <span className='regular'>{I18n.t('react.search.pagination.results', { start, end, total: displayTotal })}</span>
      <span className='mobile'>
        {I18n.t('react.search.pagination.results_mobile', { start, end, total: displayTotal })}
      </span>
      <div className='right-button'>
        <a
          className='button'
          href={nextPage ? nextPage.href : '#'}
          onClick={onlineTeachersSection ? handleGoOnlinePage : handleNextPage}
          style={{ visibility: page < pages || onlineTeachersSection ? 'visible' : 'hidden' }}
        >
          <span className='regular'>{I18n.t('main.index.next_page')}</span>
          <span className='mobile'>»</span>
        </a>
      </div>
    </div>
  )
}

export default React.memo(Pagination)
